import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Back to top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="w-full bg-slate-700 hover:bg-slate-600 py-4 text-sm transition-colors"
      >
        Retour en haut
      </button>

      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Column 1 */}
          <div>
            <h4 className="font-semibold mb-4">Pour mieux nous connaître</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/a-propos" className="hover:text-white transition-colors">À propos</Link></li>
              <li><Link to="/carrieres" className="hover:text-white transition-colors">Carrières</Link></li>
              <li><Link to="/presse" className="hover:text-white transition-colors">Presse</Link></li>
              <li><Link to="/developpement-durable" className="hover:text-white transition-colors">Développement durable</Link></li>
            </ul>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="font-semibold mb-4">Gagnez de l'argent</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/mes-boutiques" className="hover:text-white transition-colors">Vendre sur BuyMoreEasy</Link></li>
              <li><Link to="/fournisseur" className="hover:text-white transition-colors">Devenir fournisseur</Link></li>
              <li><Link to="/artisan" className="hover:text-white transition-colors">Proposer vos créations</Link></li>
              <li><Link to="/parrainage" className="hover:text-white transition-colors">Programme de parrainage</Link></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="font-semibold mb-4">Moyens de paiement</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Carte bancaire</a></li>
              <li><a href="#" className="hover:text-white transition-colors">PayPal</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Virement bancaire</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Paiement en 3x</a></li>
            </ul>
          </div>

          {/* Column 4 */}
          <div>
            <h4 className="font-semibold mb-4">Besoin d'aide ?</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/aide" className="hover:text-white transition-colors">Centre d'aide</Link></li>
              <li><Link to="/livraison" className="hover:text-white transition-colors">Livraison & retours</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Nous contacter</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-slate-700">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <div className="flex items-center gap-2">
              <span className="text-2xl">🛍️</span>
              <span className="font-bold text-xl text-orange-500">BuyMoreEasy</span>
            </div>

            {/* Links */}
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-400">
              <Link to="/conditions" className="hover:text-white transition-colors">Conditions générales</Link>
              <Link to="/confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
              <Link to="/cookies" className="hover:text-white transition-colors">Cookies</Link>
              <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
            </div>

            {/* Copyright */}
            <p className="text-xs text-gray-400">
              © 2024 BuyMoreEasy. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
